<template>
<div class="animated fadeIn">
  <b-modal
      title="Choose period"
      class="modal-primary"
      v-model="modalDate"
      @ok="fetchData(), modalDate = false"
    >
      <b-form>
        <b-form-group label="Date" label-for="date" :label-cols="3">
          <datepicker use-utc
            format="MM/dd/yyyy"
            :bootstrap-styling="true"
            v-model="date"
            name="date"
          ></datepicker>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-row>
      <b-col lg="6">
        <daily-received-stacked v-if="stackedMonth" @switch="switchChartMonth" />
        <ReceivedByFNS v-else ref="shipLine" @switch="stackedMonth = !stackedMonth" :dateFrom="myDateMonth" :dateTo="myDateMonthTo" :alpha="alpha" :month="true"></ReceivedByFNS>

      </b-col>
      <b-col lg="6">
        <daily-received-date-stacked v-if="stacked" @switch="switchChart"/>
        <ReceivedByFNS v-else ref="shipLine" @switch="stacked = !stacked" :dateFrom="myDate" :dateTo="myDate" :alpha="alpha" :month="false"></ReceivedByFNS>

      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" class="text-center mb-3">
      <b-button
          @click="modalDateEvent"
          class
          style="height: 46px; width: 46px"
          variant="transparent p-0"
        >
          <i class="icon-calendar" style="color: #20a8d8;font-size:35px"></i>
        </b-button>

        {{ $formatUSDate(from) }}
      </b-col>
      <b-col
        lg="12"
        style="display:block;padding-bottom:15px;font-size:1.2em;"
        v-if="total>0"
      >
        <span style="padding:5px; text-align:left;">Total Records:</span>
        <b style="padding-right:5px;">{{total}}</b>
        
        <b-button
          class="download-button ml-3"
          variant="primary"
          size="lg"
          @click="downloadExcel();"
        >
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>

      </b-col>
      <b-col lg="12">
        <c-table :table-data="rows" :fields="columns" :caption="'Daily Receiving'"></c-table>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import cTable from "./Table.vue";
import Datepicker from "vuejs-datepicker";
import DailyReceivedStacked from '../../components/DailyReceived-Stacked.vue';
import DailyReceivedDateStacked from '../../components/DailyReceivedDate-Stacked.vue';
import ReceivedByFNS from "../../components/ReceivedByFNS-ColumnAlphaDaily";

export default {
  components: { ReceivedByFNS, cTable, Datepicker, DailyReceivedStacked, DailyReceivedDateStacked },
  data() {
    return {
      modalDate: false,
      columns: [
        {
          key: "fnsid",
          align: "left",
          label: "FNSID",
          field: "fnsid",
          sortable: true,
        },
        {
          key: "fnsra",
          align: "left",
          label: "FNSRA",
          field: "fnsra",
          sortable: true,
        },
        {
          key: "serNum",
          align: "left",
          label: "Serial#",
          field: "serNum",
          sortable: true,
        },

        { key: 'location', label: "Location", field: "location", sortable: true },
        { label: "Manufacturer", key: "prodMake" },
        { key: "model", label: "Model", key: "prodModel", sortable: true },
        // { key: "complaint", label: "Complaint", field: "complaint" },
        // { key: "status", label: "Status", field: "status", sortable: true },
      ],
      loading: true,
      total: 0,
      rows: [],
      stacked: true,
      stackedMonth: true,
      myDate: '',
      myDateMonth: '',
      myDateMonthTo: '',
      alpha: '',
      model: "XM3",
      modelOptions: ["XM3"], //["All", "XM3", "XM2"],
      date: new Date().toJSON().slice(0, 10),
    };
  },

computed: {
    from() {
      if (typeof this.date === "object") {
        this.date = this.date.toISOString().split("T")[0];
        return this.date;
      } else {
        return this.date
      }
    },
  },

  methods: {
    switchChartMonth (data) {
      console.log('y')
      this.alpha = data[0]
      this.myDateMonth = data[1]
      this.myDateMonthTo = data[1].slice(0, 8) + '31'
      this.stackedMonth = false
    },

    switchChart (data) {
      this.alpha = data[0]
      this.myDate = data[1] 
      this.stacked = false
    },

    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },

    fetchData() {
      this.loading = true;
      const params = {
        date: this.date,
        alpha: this.model,
        xml: false
      }
      this.$http
        .get("api/alpha/tables/daily-receiving.php", { params })
        .then(res => {      
          this.rows = res.data.records;
          this.total = res.data.count;
          this.loading = false;
        })
    },
    downloadExcel() {
      this.loading = true;
      const params = {
        date: this.date,
        alpha: this.model,
        xml: true
      }
      this.$http
        .get("api/alpha/tables/daily-receiving.php", {params, responseType: "blob"})
        .then(res => {      
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "TableReport.xlsx");
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>